import dayjs from "dayjs";
import store from "./redux/store";
import { isPermission } from "./Permissions/PermissionsOnRouteChange";

export const StaticHrEmail = 'sanchita.roy@choiceindia.com'

export const attendance = {

    workflow_type: [
        {
            name: "Attendance Regularization",
            slug: "attendance_regularization"
        },
        {
            name: "Absenteeism",
            slug: "absenteeism"
        },
        {
            name: "Outdoor Duty",
            slug: "outdoor_duty"
        },
        {
            name: "Grace Period",
            slug: "grace_period"
        },
        {
            name: "Compensatory Off",
            slug: "compensatory_off"
        },
        {
            name: "Leave",
            slug: "leave"
        }
    ],

    approver_role: [
        {
            name: "Reporting Manager",
            slug: "reporting_manager",
        },
        {
            name: "Branch Head",
            slug: "branch_head",
        },
        {
            name: "Vertical Head",
            slug: "vertical_head",
        },
        {
            name: "HR",
            slug: "hr",
        },

    ],


}


type DateInBetweenSign = "/" | "-";

export const OrganizationRoles: any = {
    reporting_manager: "Reporting Manager",
    team: "Team Member"
}


//show date in perticular format
export const dateFormat_DDMMYYY = (dateValue: string | null | undefined, DateInBetweenSign: string): string => {    
    try {
        if (!dateValue || dateValue?.trim() === "") {
            return "-";
        }

        return dayjs(dateValue).format(`DD${DateInBetweenSign}MM${DateInBetweenSign}YYYY`);
    } catch (e: any) {
        return "-"
    }
}


export const toTitleCase = (str: string): string => {
    try {
        const minorWords = new Set([
            'a', 'an', 'the', 'and', 'but', 'or', 'for', 'nor', 'so', 'yet',
            'at', 'by', 'in', 'of', 'on', 'to', 'up', 'with'
        ]);
        return str.split(' ').map((word, index, arr) => { return (index === 0 || index === arr.length - 1 || !minorWords.has(word.toLowerCase())) ? capitalize(word) : word.toLowerCase(); }).join(' ');
    }
    catch (e: any) {
        return str;
    }
}

function capitalize(word: string): string {
    return word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase();
}


export const handleDynamicFinancialYear = () => {
    const currentMonth = new Date().getMonth(); // Get current month (0-indexed, 0 = January, 11 = December)
    const currentYear = new Date().getFullYear();
    let startYear: number;
    let endYear: number;
    if (currentMonth >= 3) { // Month is April (3) or above
        startYear = currentYear;
        endYear = currentYear + 1;
    } else { // Month is below April (January, February, March)
        startYear = currentYear - 1;
        endYear = currentYear;
    }
    return `${startYear}-${endYear}`;
}

export const isAllowUpdateCandidateStage = (assigned_to: any) => {
    const loginUser: any = store.getState()?.authUser?.user ?? {};
    const isOnlyHr = isPermission("update-candidate_stage");
    const isOnlyApproval = loginUser?.user_id === Number(assigned_to ? assigned_to : 0);
    if (isOnlyHr || isOnlyApproval) {
        return true;
    }
    return false;
}

export const isAllowUpdateJobStatus = (approval_id: any, jobObject:any ) => {
    const loginUser: any = store.getState()?.authUser?.user ?? {};
    const isHr = isPermission("update-job_status");
    const isClosePermission = (isPermission("update-job_status_close") && jobObject?.job_status === "approved");
    const isApproval = loginUser?.user_id === (approval_id ? approval_id : 0)
    if (isHr || isApproval || isClosePermission ) {
        return true;
    }
    return false;
}

export const positionType: any = {
    full_time: "Full Time",
    part_time: "Part Time",
    freelance: "Freelancing",
    internship: "Internship",
    apprenticeship: "Apprenticeship"
}

export const Gender_options: Array<Object> = [
    { label: 'Male' },
    { label: 'Female' },
    { label: 'Other' },
];

// Below are monthly Price cap limit
export const Price_cap_limit:any = {
    EMPLOYEE_EPF: 15000,
    EMPLOYER_EPF: 15000,
}

export const ESI_REQUIRED_FOR_GROSS_LIMIT = 21000
export const CAR_EXPENSE_LIMIT = 300000
export const CHAFFEUR_ALLOWANCE_LIMIT = 300000

export const leaveTypes = {
    leave_without_pay_leave: {
        name: "Leave Without Pay",
        code: "LWP",
        policyRule: [
            "Is Half Day Leave Allow(HDLA)",
            "Is Past Day Leave Allow(PDLA)",
            "Is Leave Allowed In Probation(LAIP)",
            "Is Sandwich Leave Allow(SLA)",
            "Is Required Document Upload(RDU)",
            "IS Description(D)",

            //Policy cannot be set below this - rule.
            //"Can add Total Leave Limit(ATLL)",
            // "Is Carry Forward Leave(CFL)",
            //  "Is Encashable Leave(EL)",
        ]
    },
    paid_leave: {
        name: "Paid Leave",
        code: "PL",
        policyRule: [
            "Can add Total Leave Limit(ATLL)",
            "Is Half Day Leave Allow(HDLA)",
            "Is Carry Forward Leave(CFL)",
            "Is Encashable Leave(EL)",
            "Is Past Day Leave Allow(PDLA)",
            "Is Sandwich Leave Allow(SLA)",
            "Is Required Document Upload(RDU)",

            //Policy cannot be set below this - rule.
            // "Is Leave Allowed In Probation(LAIP)",

        ]
    },
    maternity_leave: {
        name: "Maternity Leave",
        code: "ML",
        policyRule: [
            "Can add Total Leave Limit(ATLL)",
            "Is Carry Forward Leave(CFL)",
            "Is Encashable Leave(EL)",
            "Is Past Day Leave Allow(PDLA)",
            "Is Sandwich Leave Allow(SLA)",
            "Is Required Document Upload(RDU)",

            //Policy cannot be set below this - rule.
            // "Is Half Day Leave Allow(HDLA)",
            //"Is Leave Allowed In Probation(LAIP)",
        ]
    },
    paternity_leave: {
        name: "Paternity Leave",
        code: "PTL",
        policyRule: [
            "Can add Total Leave Limit(ATLL)",
            "Is Carry Forward Leave(CFL)",
            "Is Encashable Leave(EL)",
            "Is Past Day Leave Allow(PDLA)",
            "Is Sandwich Leave Allow(SLA)",
            "Is Required Document Upload(RDU)",

            //Policy cannot be set below this - rule.
            // "Is Half Day Leave Allow(HDLA)",
            //"Is Leave Allowed In Probation(LAIP)",
        ]
    },
    compensatory_off_leave: {
        name: "Compensatory Off",
        code: "CMPOF",
        policyRule: [

            "Is Half Day Leave Allow(HDLA)",
            "Is Carry Forward Leave(CFL)",
            "Is Encashable Leave(EL)",
            "Is Past Day Leave Allow(PDLA)",
            "Is Leave Allowed In Probation(LAIP)",
            "Is Sandwich Leave Allow(SLA)",
            "Is Required Document Upload(RDU)",

            //Policy cannot be set below this  - rule.
            //"Can add Total Leave Limit(ATLL)",
        ]
    },
    miscarriage_leave: {
        name: "Miscarriage Leave",
        code: "MISCL",
        policyRule: [
            "Can add Total Leave Limit(ATLL)",
            "Is Carry Forward Leave(CFL)",
            "Is Encashable Leave(EL)",
            "Is Past Day Leave Allow(PDLA)",
            "Is Sandwich Leave Allow(SLA)",
            "Is Required Document Upload(RDU)",

            //Policy cannot be set below this -  rule.
            // "Is Half Day Leave Allow(HDLA)",
            //"Is Leave Allowed In Probation(LAIP)",
        ]
    }
}

export const familyDetailsOptions = [
    { label: "Spouse", value: "Spouse" },
    // { label: "Parent", value: "Parent" },
    { label: "Sibling", value: "Sibling" },
    { label: "Child", value: "Child" },
    { label: "Other", value: "Other" },

    { label: "Father", value: "Father" },
    { label: "Mother", value: "Mother" },
    { label: "Brother", value: "Brother" },
    { label: "Sister", value: "Sister" },
    { label: "Father In Law", value: "Father_in_law" },
    { label: "Mother In Law", value: "Mother_in_law" },
];


export const user_confirmation_status = {
    probation: "probation",
    inprogress: "inprogress",
    confirmed: "confirmed",
    extended: "extended",
    reject: "reject",
    notice_period: "notice_period",
    relieved: "relieved"
}

export const staticPayloadDataForApi = {
    ProbationConfirmationListExportService: {
        methods: ['fetchConfirmationExportReport'],
        api: "employee/confirmation/list-for-admin",
        payload: {
            generate_excel: "yes",
        },
    },
    AdminPIPListExportService: {
        methods: ['fetchPIPExportReport'],
        api: "report/pip-report",
        payload: {
            generate_excel: "yes",
        },
    },
    HolidayMasterAllUpdateService: {
        methods: ['formik.onSubmit'],
        api: "holiday-master/update-holiday",
        payload: {
            policy_type: "custom",
        },
    },
    getWeekOffMasterService: {
        methods: ['getWeekOffData'],
        api: "weekoff-master/get",
        payload: {
            policy_type: "custom",
        },
    },
    getDeductionListService: {    // exist in multiple Services
        methods: ['getDeductionListing'],
        api: "payrole/masters-component/deduction/list",
        payload: {
            limit: 1000,
            offset: 0,
        },
    },
    getProbationQuestionListService: {
        methods: ['fetchQuestions'],
        api: "employee/confirmation/question-list",
        payload: {
            company_id: 12
        },
    },
    dailyTicketCountFetch: {
        methods: ['getDailyTicketCount'],
        api: "ticket/day-wise-statistics",
        payload: {
            from_date: "2024-01-01"
        },
    },
    RecruiterListService: {
        methods: ['getRecruiterList'],
        api: "employee/options",
        payload: {
            "id": 12, "type": "approver"
        },
    },
}

export const GlobalPermissionsPath = "/global-permissions"

//static  passing 
//IN EmployeeExitForm component
//for showing last  Tentative Last Working Day
// const daysToAdd = (policyData && policyData[0] && policyData[0].notice_period) !== undefined ? policyData[0].notice_period : 30;


export const template_type_option =  [
    { "label": "Fresher", "value": "fresher" },
    { "label": "Experienced", "value": "experienced" },
    // { "label": "ESIC Eligible", "value": "esic" }
  ]
export const educationDegree = [
    { label: "Diploma", id: 1 },
    { label: "Graduation", id: 2 },
    { label: "Post Graduation", id: 3 },
    { label: "10th", id: 4 },
    { label: "12th", id: 5  },
];


export const EarlyAccessDaysForConfirmationButtonBeforeConfirmationDate = 15

export const FunctionalRole: any = {
    "1": "RM",  //Reporting Manager
    "2": "Branch Head",
    "3": "Vertical Head",
    "4": "HR",
    "5": "Finance",
    "6": "IT",
    "7": "Admin",
    // "8" : "",
    "9": "Full and Final",
    "10": "Full and Final TDS",
    "11": "Loan Team",
    "12": "Branch Compliance",
    "13": "Business Head",
    "14": "Head of Department",
    "15": "Accounts",
    "16": "Connect",
    "17": "Prime",
    "18": "KYC",
    "19": "MIS",
    "20": "ODIN",
    "21": "Techexcel",
    "22": "Freshdesk",
    "23": "Compliance",





    //UAT
    // "11": "Business Head",
    // "12": "Head Of Department",
    // "13": "Accounts"
}
